import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'add-to-portfolio',
  components: {},
  props: {"securityData": null},
  data () {
    return {
      isOpen: false,
      portfolioData: [],
      addValueToWatchlist: {},
      isPortfolioValid: true,
      isWatchlistSubSuccessful: false,
      isEndpointError: false,
      isin:this.$route.params.ISIN,
    }
  },
  computed: {
    ...mapGetters(['get_UP_portfolios'])
  },
  mounted () {

  },
  async created(){
    await this.$store.dispatch('load_UP_portfolios')
    this.portfolioData = this.get_UP_portfolios.data;
  },
  methods: {
    openModal(){
      this.addValueToWatchlist = this.securityData
      this.isOpen = true;
      
    },
    closeModal(){
      this.isOpen = false;
    },
    ...mapActions(['load_UP_portfolios']),
    async postValueToWatchlist(){
      if(this.addValueToWatchlist.portfolio_id == null){
        this.isPortfolioValid = false
      }else{
        let data = {
          "portfolio_id": this.addValueToWatchlist.portfolio_id,
          "isin": this.isin,
          "watch_date": new Date().toISOString().split('T')[0],
          "watch_price": 0,
  
        }
        try{
          var priceData
          priceData = await this.accessEndpoint('securityPriceHistory/?isin=' + this.isin +'&format=json');
          data.watch_price = priceData["prices"][priceData["prices"].length - 1]
          console.log("prices", priceData, data.watch_price)
          this.closeModal();
          await this.verifyToken();
          await this.postEndpoint(data, 'addWatch/');
          setTimeout(() => this.isWatchlistSubSuccessful = true, 200)
          setTimeout(() => this.isWatchlistSubSuccessful = false, 3000)
        }catch{
          this.showErrorNotification();
        }

      }

    }
  }
}


